import React from "react";

import CreatorFreeAccessView from "../views/CreatorAccessView";

export default function CreatorFreeAccessPage({ userId, username }) {
  return <CreatorFreeAccessView userId={userId} username={username} />;
}
